export default "__VITE_ASSET__4612eeeb__"